import React from "react";
import { useState, useEffect } from "react";
import BackButton from "../base/BackButton";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Button from "../base/Button";
import * as FaIcons from "react-icons/fa";
import Swal from "sweetalert2";

function TotalPriority() {
  const [activeTab, setActiveTab] = useState("all_priority");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterKey, setFilterKey] = useState(0);
  const [clientName, setClientName] = useState("");
  const [instituteProvider, setInstituteProvider] = useState("");
  const [appType, setAppType] = useState("");

  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [updatedDate, setUpdatedDate] = useState(null);
  const [notes, setNotes] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);

  const [openViewModal, setOpenViewModal] = useState(false);

  useEffect(() => {
    fetchData();
  }, [activeTab]);
  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.perPage, filterKey]);

  const fetchData = async () => {
    let category = "";
    setLoading(true);
    if (activeTab === "all_priority") {
      category = "all";
    } else if (activeTab === "education_priority") {
      category = "education";
    } else if (activeTab === "migration_priority") {
      category = "migration";
    }
    const params = {
      page: pagination.currentPage,
      perPage: pagination.perPage,
      category,
      client_name: clientName.trim(),
      provider_name: instituteProvider.trim(),
      course_name: appType.trim(),
    };
    try {
      const response = await apiUrl.get("/applications/total_priority", {
        category,
        params,
      });
      if (response?.status) {
        setData(
          Array.isArray(response?.data?.data?.items)
            ? response.data.data.items
            : []
        );
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.data?.meta?.total || 0,
          lastPage: response?.data?.data?.meta?.lastPage || 1,
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const calculateDaysMessage = (selectedDate) => {
    const today = new Date();
    const priorityDate = new Date(selectedDate);
    const timeDiff = priorityDate - today;
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    if (daysDiff > 0) {
      return `${daysDiff} day(s) left.`;
    } else if (daysDiff < 0) {
      return `${Math.abs(daysDiff)} day(s) overdue.`;
    } else {
      return "Today is the priority date.";
    }
  };

  //   function to update priority date
  const updatePriorityDate = async () => {
    if (!updatedDate) {
      Swal.fire("Error", "Please select a date.", "error");
      return;
    }
    if (!notes.trim()) {
      Swal.fire(
        "Error",
        "Please provide a reason for changing the date.",
        "error"
      );
      return;
    }
    setUpdateLoading(true);
    // API call to update priority date
    try {
      const response = await apiUrl.put(
        `/applications/update_priority_date/${selectedItem?.id}`,
        {
          priority_date: updatedDate,
          notes: notes.trim(),
          app_type: selectedItem?.type,
        }
      );
      if (response?.status) {
        Swal.fire("Success", "Priority date updated successfully.", "success");
        setOpen(false);
        fetchData();
      }
    } catch (error) {
      console.error("Error updating priority date:", error);
      Swal.fire(
        "Error",
        "There was an error updating the priority date. Please try again.",
        "error"
      );
    } finally {
      setUpdateLoading(false);
    }
  };
  //   delete the application priority
  const deleteApplciationPriority = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await apiUrl.delete(
          `/applications/delete_priority/${selectedItem?.id}/${selectedItem?.type}`
        );
        if (response?.status) {
          Swal.fire("Deleted!", "Priority deleted successfully.", "success");
          fetchData();
        }
      } catch (error) {
        console.error("Error deleting priority:", error);
        Swal.fire(
          "Error",
          "There was an error deleting the priority. Please try again.",
          "error"
        );
      }
    }
  };
  return (
    <>
      <div className="card px-4 py-3 bg-white">
        {/* Header */}
        <header className="mb-3">
          <div className="flex align-center gap-5 flex-wrap">
            <div className="flex align-center">
              <BackButton url="/dashboard" />
            </div>
            <h1 className="h4 font-semibold">Total Priority</h1>
          </div>
        </header>
        {/* filter */}
        <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4">
          {/* Filter Row */}
          <div className="flex flex-wrap gap-4 mb-3">
            {/* Client */}
            <div className="flex-1 min-w-[180px]">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Client
              </label>
              <input
                className="form-control"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
                placeholder="Client Name"
              />
            </div>
            {/* provider */}
            <div className="flex-1 min-w-[180px]">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Institute/Provider
              </label>
              <input
                className="form-control"
                value={instituteProvider}
                onChange={(e) => setInstituteProvider(e.target.value)}
                placeholder="Institute/Provider"
              />
            </div>
            <div className="flex-1 min-w-[180px]">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                App Type
              </label>
              <input
                className="form-control"
                value={appType}
                onChange={(e) => setAppType(e.target.value)}
                placeholder="App Type"
              />
            </div>
          </div>
          <div className="flex items-center justify-end gap-2">
            <div>
              <Button
                text="Clear All"
                variant="outline"
                size="sm"
                onClick={() => {
                  setFilterKey((prev) => prev + 1);
                  setClientName("");
                  setInstituteProvider("");
                  setAppType("");
                }}
              />
            </div>
            <div>
              <Button
                text="Apply Filter"
                variant="primary"
                size="sm"
                onClick={() => {
                  setPagination((prev) => ({ ...prev, currentPage: 1 }));
                  setFilterKey((prev) => prev + 1);
                }}
              />
            </div>
          </div>
        </div>
        {/* table and tabs */}
        <div className="container px-4 py-3">
          {/* Tabs */}
          <ul className="nav nav-tabs mb-4" role="tablist">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "all_priority" ? "active" : ""
                }`}
                onClick={() => setActiveTab("all_priority")}
              >
                All Priority Applications
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "education_priority" ? "active" : ""
                }`}
                onClick={() => setActiveTab("education_priority")}
              >
                Education Priority Applications
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "migration_priority" ? "active" : ""
                }`}
                onClick={() => setActiveTab("migration_priority")}
              >
                Migration Priority Applications
              </button>
            </li>
          </ul>
          {/* Tabs content */}
          <div className="tab-content">
            <div
              className={`tab-pane ${
                activeTab === "all_priority" ? "active" : ""
              }`}
            ></div>
            <div
              className={`tab-pane ${
                activeTab === "education_priority" ? "active" : ""
              }`}
            ></div>
            <div
              className={`tab-pane ${
                activeTab === "migration_priority" ? "active" : ""
              }`}
            ></div>
          </div>
        </div>

        {/* table */}
        <table className="table w-full">
          <thead>
            <tr>
              <th>Client</th>
              <th>Category</th>
              <th>Institute/Provider </th>
              <th>App Type</th>
              <th>Status</th>
              <th>Achieve Status</th>
              <th>Status Changed</th>
              <th>Assigned To</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {/* ---------- SKELETON (DaisyUI style) ---------- */}
            {loading ? (
              <>
                {[...Array(5)].map((_, i) => (
                  <tr key={i} className="border-b">
                    {/* Client */}
                    <td className="py-3">
                      <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Category */}
                    <td className="py-3">
                      <div className="h-4 w-20 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Institute/Provider */}
                    <td className="py-3">
                      <div className="h-4 w-32 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* App Type */}
                    <td className="py-3">
                      <div className="h-4 w-28 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Status */}
                    <td className="py-3">
                      <div className="h-4 w-20 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Achieve Status */}
                    <td className="py-3">
                      <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Status Changed */}
                    <td className="py-3">
                      <div className="h-4 w-28 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* Assigned To */}
                    <td className="py-3">
                      <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                    {/* action */}
                    <td className="py-3">
                      <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                    </td>
                  </tr>
                ))}
              </>
            ) : data?.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="py-12 text-center text-gray-500 text-lg font-medium border-t"
                >
                  No data found.
                </td>
              </tr>
            ) : (
              /* ---------- REAL ROWS (your original logic) ---------- */
              data?.map((item, index) => (
                <tr key={item?.id}>
                  <td className=" align-middle">
                    <Link
                      to={`/clients/view-client-detail/${item?.client?.id}`}
                    >
                      {item?.client?.name}
                    </Link>
                  </td>

                  <td className=" align-middle">{item?.type}</td>
                  <td className=" align-middle">{item?.provider?.name}</td>
                  <td className=" align-middle">
                    {item?.type === "migration" ? (
                      <Link
                        to={`/applications/view-migration-application-detail/${item?.course?.id}`}
                      >
                        {item?.course?.name}
                      </Link>
                    ) : (
                      <Link
                        to={`/applications/view-education-application-detail/${item?.course?.id}`}
                      >
                        {item?.course?.name}
                      </Link>
                    )}
                  </td>

                  <td className=" align-middle">{item?.status}</td>
                  <td className=" align-middle flex flex-col items-center">
                    <small className="name-text">
                      [{item?.priority_status}]
                    </small>
                    <div className="text-center error">
                      {calculateDaysMessage(item?.priority_date)}
                    </div>
                  </td>
                  <td className=" align-middle">{item?.statuschangedate}</td>
                  <td className=" align-middle">{item?.assignedTo}</td>
                  <td className=" align-middle">
                    <div className="flex gap-1">
                      <button
                        className="btn btn-primary"
                        isDisabled={loading}
                        onClick={() => {
                          setSelectedItem(item);
                          setNotes("");
                          setUpdatedDate(item?.priority_date);
                          setOpen(true);
                        }}
                      >
                        <FaIcons.FaEdit />
                      </button>
                      <button
                        className="btn btn-warning text-white"
                        isDisabled={loading}
                        onClick={() => {
                          setSelectedItem(item);
                          setOpenViewModal(true);
                        }}
                      >
                        <FaIcons.FaEye />
                      </button>
                      <button
                        className="btn btn-danger text-white"
                        isDisabled={loading}
                        onClick={() => {
                          setSelectedItem(item);
                          deleteApplciationPriority();
                        }}
                      >
                        <FaIcons.FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {/* modal */}
        {open && (
          <>
            <div
              className="modal-backdrop fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.45)",
                zIndex: 1040,
              }}
              onClick={() => setOpen(false)}
            />

            <div
              className="modal fade show d-block h-full"
              tabIndex={-1}
              style={{ zIndex: 1050 }}
            >
              <div
                className="modal-dialog modal-md modal-dialog-centered h-full"
                style={{ maxWidth: 800 }}
              >
                <div className="modal-content border-0 rounded-4 shadow">
                  <div
                    className="modal-header"
                    style={{
                      background: "#f7f8fa",
                      borderBottom: "1px solid #eef2f6",
                    }}
                  >
                    <h5 className="modal-title fw-bold">
                      Update Priority Achievement Date
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setOpen(false)}
                    />
                  </div>

                  {/* Modal Body */}
                  <div className="modal-body">
                    <div className="col-4">
                      <label className="form-label fw-semibold">
                        Priority Achievement Date
                      </label>
                      <input
                        type="date"
                        required
                        className="form-control"
                        value={updatedDate || ""}
                        onChange={(e) => setUpdatedDate(e.target.value)}
                      />
                    </div>
                    <div className="mt-3">
                      <label className="form-label fw-semibold">
                        Provide Reason Why You are Changing the Date
                      </label>
                      <textarea
                        className="form-control"
                        required
                        rows="4"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                      ></textarea>
                    </div>
                  </div>

                  {/* Footer */}
                  <div
                    className="modal-footer d-flex justify-content-end align-items-center gap-2"
                    style={{
                      background: "#f7f8fa",
                      borderTop: "1px solid #eef2f6",
                    }}
                  >
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setOpen(false)}
                      disabled={updateLoading}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-success"
                      onClick={() => {
                        updatePriorityDate();
                      }}
                      disabled={updateLoading}
                    >
                      {updateLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Updating...
                        </>
                      ) : (
                        <>Update</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* view modal */}
        {openViewModal && (
          <>
            <div
              className="modal-backdrop fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.45)",
                zIndex: 1040,
              }}
              onClick={() => setOpenViewModal(false)}
            />

            <div
              className="modal fade show d-block h-full"
              tabIndex={-1}
              style={{ zIndex: 1050 }}
            >
              <div
                className="modal-dialog modal-md modal-dialog-centered h-full"
                style={{ maxWidth: 800 }}
              >
                <div className="modal-content border-0 rounded-4 shadow">
                  <div
                    className="modal-header"
                    style={{
                      background: "#f7f8fa",
                      borderBottom: "1px solid #eef2f6",
                    }}
                  >
                    <h5 className="modal-title fw-bold">
                      View Priority Achievement Date Details
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setOpenViewModal(false)}
                    />
                  </div>

                  {/* Modal Body */}
                  {/* Modal Body */}
                  <div className="modal-body p-4 max-h-96 overflow-y-auto">
                    {selectedItem.priority_date_history &&
                    selectedItem.priority_date_history.length > 0 ? (
                      <table className="w-full table-auto border-collapse">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border px-3 py-2 text-left">
                              Changed By
                            </th>
                            <th className="border px-3 py-2 text-left">
                              Changed At
                            </th>
                            <th className="border px-3 py-2 text-left">
                              Old Date
                            </th>

                            <th className="border px-3 py-2 text-left">
                              Reason
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedItem?.priority_date_history.map(
                            (history, idx) => (
                              <tr
                                key={idx}
                                className={
                                  idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                                }
                              >
                                <td className="border px-3 py-2">
                                  {history?.changed_by}
                                </td>
                                <td className="border px-3 py-2">
                                  {history?.changed_at}
                                </td>
                                <td className="border px-3 py-2">
                                  {history?.old_date}
                                </td>

                                <td className="border px-3 py-2">
                                  {history?.reason}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <p className="text-gray-500">
                        No priority date history available.
                      </p>
                    )}
                  </div>

                  {/* Footer */}
                  <div
                    className="modal-footer d-flex justify-content-end align-items-center gap-2"
                    style={{
                      background: "#f7f8fa",
                      borderTop: "1px solid #eef2f6",
                    }}
                  >
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setOpenViewModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* pagiantion */}
        <div className="row align-items-center mb-5 mt-2">
          <div className="col-auto">
            <select
              value={pagination?.perPage}
              onChange={handlePerPageChange}
              className="form-select"
              style={{ minWidth: 80 }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
          <div className="col-auto text-muted">
            Page {pagination.currentPage} – Showing{" "}
            {Math.min(
              pagination.perPage,
              pagination.total -
                (pagination.currentPage - 1) * pagination.perPage
            )}{" "}
            of {pagination.total} entries
          </div>
          <div className="col">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pagination.lastPage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageChange}
              forcePage={pagination.currentPage - 1}
              containerClassName={"pagination justify-content-end mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default TotalPriority;
